export default {
  login: '/admin/login/',
};
